import './styles/datatype-item.scss'

import React       from 'react'
import PropTypes   from 'prop-types'

export default class DataTypeItem extends React.Component {
  static propTypes = {
    item: PropTypes.object.isRequired,
  }
  
  render() {
    const { item } = this.props

    return (
      <div className="datatype-item">        
        { item.name }        
      </div>      
    )
  }
}